module.exports = __webpack_public_path__ + "assets/1b727d3300ddd2ecb5a6335162272da6.mp3";